var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtocol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00977 1.25269C5.00977 0.56233 5.56941 0.00268555 6.25977 0.00268555H9.75391C10.4443 0.00268555 11.0039 0.562329 11.0039 1.25269V2L12.5 2C13.3284 2 14 2.67157 14 3.5L14 13.5C14 14.3284 13.3284 15 12.5 15L3.5 15C2.67157 15 2 14.3284 2 13.5V3.5C2 2.67157 2.67157 2 3.5 2L5.00977 2V1.25269ZM9.75391 4.50269C10.3596 4.50269 10.8647 4.0719 10.9794 3.5H12C12.2761 3.5 12.5 3.72386 12.5 4L12.5 13C12.5 13.2761 12.2761 13.5 12 13.5L4 13.5C3.72386 13.5 3.5 13.2761 3.5 13L3.5 4C3.5 3.72386 3.72386 3.5 4 3.5L5.03423 3.5C5.14901 4.0719 5.65408 4.50269 6.25977 4.50269H9.75391ZM6.50977 1.50269V3.00269H9.50391V1.50269H6.50977ZM5.75 7C5.33579 7 5 7.33579 5 7.75C5 8.16421 5.33579 8.5 5.75 8.5H10.25C10.6642 8.5 11 8.16421 11 7.75C11 7.33579 10.6642 7 10.25 7H5.75ZM5.75 10C5.33579 10 5 10.3358 5 10.75C5 11.1642 5.33579 11.5 5.75 11.5H8.25C8.66421 11.5 9 11.1642 9 10.75C9 10.3358 8.66421 10 8.25 10H5.75Z",
    fill: "#009866"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocol);
export default __webpack_public_path__ + "static/media/protocol.234c3aef1989f8dcb4182e30e1c19c90.svg";
export { ForwardRef as ReactComponent };